import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id B844FAFE-5491-4441-9C3E-23F2AB148E10
 * name alpha-w-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-w-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaWBoxOutlineIcon = createSvgIcon(<><path d="M9,17A2,2 0 0,1 7,15V7H9V15H11V8H13V15H15V7H17V15A2,2 0 0,1 15,17H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z" /></>, 'AlphaWBoxOutlineIcon');
export default AlphaWBoxOutlineIcon